module.exports = __webpack_public_path__ + "static/media/VestasSans-Headline.a20cadb8.svg";